import axios from 'axios';
import getSBABaseUrl from 'lib/getSBABaseUrl';
import { normalize, schema } from 'normalizr';
import { addTilstandsrapportEntities } from 'store/tilstandsrapportEntities/actions';
import { ReportActionCreators, ReportActionTypes } from './types';

// Normalizr
const sjekkpunkter = new schema.Entity('sjekkpunkter', {}, { idAttribute: 'id' });
const tilstandsrapport = new schema.Entity('tilstandsrapport', { sjekkpunkter: [sjekkpunkter] });

export const reportRequest = (): ReportActionCreators => {
  return { type: ReportActionTypes.REQUEST };
};

export const reportFailure = (error): ReportActionCreators => {
  return { type: ReportActionTypes.FAILURE, error };
};

export const reportSuccess = (): ReportActionCreators => {
  return { type: ReportActionTypes.SUCCESS };
};

export const setActiveReport = (tilstandsrapportId: string): ReportActionCreators => {
  return { type: ReportActionTypes.SET_ACTIVE_REPORT, tilstandsrapportId };
};

export const setCompareReport = (tilstandsrapportId: string): ReportActionCreators => {
  return { type: ReportActionTypes.SET_COMPARE_REPORT, tilstandsrapportId };
};

/*
 TODO:
 Methods below are almost identical. I've decided to keep it like this
 untill we've figured out exactly how we want to compare properties.
 */

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const doFetchReport = (id: string, cookie = null) => {
  return async (dispatch): Promise<void> => {
    dispatch(reportRequest());
    try {
      const { data } = await axios.get(`${getSBABaseUrl()}/api/analyser/${id}`, {
        withCredentials: true,
        headers: { cookie },
      });
      dispatch(setActiveReport(id));
      dispatch(reportSuccess());
      dispatch(addTilstandsrapportEntities(normalize(data, tilstandsrapport)));
    } catch (err) {
      dispatch(reportFailure(err));
    }
  };
};

export const fetchCompareReport = (id: string, cookie = null) => {
  return async (dispatch): Promise<void> => {
    dispatch(reportRequest());
    try {
      const { data } = await axios.get(`${getSBABaseUrl()}/api/analyser/${id}`, {
        withCredentials: true,
        headers: { cookie },
      });
      dispatch(setCompareReport(id));
      dispatch(reportSuccess());
      dispatch(addTilstandsrapportEntities(normalize(data, tilstandsrapport)));
    } catch (err) {
      dispatch(reportFailure(err));
    }
  };
};
